import React from 'react';
// @ts-ignore
import styles from './AccountPagePanel.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	children: React.ReactElement | React.ReactElement[];
	title: string;
	text?: string;
}

const AccountPagePanel: React.FC<Props> = ({ children, title, text }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<h1 className={styles.title}>{t(title)}</h1>
			{text && <Text tx={text} className={styles.text} />}
			{children}
		</div>
	);
};

export default AccountPagePanel;
